import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { AppRedirectComponent } from './app-redirect.component';
import { User, UserService, ROLE } from './user';
import { UserModule } from './user/user.module';
import { UiModule } from './ui';
import { NotifyModule, NotifyService } from './notify';
import { noop, PrimeNgLocaleModule } from './shared';
import { SecurityModule } from './security';
import { PermissionModule, PermissionService } from './security/permission';
import { AuthHttpService } from './security/authorization';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_STATUS_CODE } from './shared/http-status-code.enum'
import { CookieInfoModule } from './ui/cookie-info/cookie-info.module';
import { LanguageModule } from './language/language.module';
import { WebpackTranslateLoader } from './webpack-translate-loader';

@NgModule({
  declarations: [
    AppComponent,
    AppRedirectComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: WebpackTranslateLoader
      }
    }),
    UiModule,
    CookieInfoModule,
    NotifyModule,
    SecurityModule,
    AppRoutingModule,
    PermissionModule.forRoot(),
    LanguageModule.forRoot(),
    PrimeNgLocaleModule.forRoot()
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(
    router: Router,
    authHttpService: AuthHttpService,
    permissionService: PermissionService,
    userService: UserService,
    notify: NotifyService
  ) {

    permissionService.defineRole(
      ROLE.GUEST,
      (): any => userService.getUser()
        .then(
          (user: User): boolean => user === null
        )
    );
    permissionService.defineRole(
      ROLE.USER,
      () => userService.getUser()
        .then(
          (user: User) => user !== null
        )
    );
    permissionService.defineRole(
      ROLE.PARTICIPANT,
      (): any => userService.getUser()
        .then(
          (user: User): boolean => user !== null && user.hasRole(ROLE.PARTICIPANT)
        ),
      [ROLE.USER]
    );
    permissionService.defineRole(
      ROLE.COACH,
      (): any => userService.getUser()
        .then(
          (user: User): boolean => user !== null && user.hasRole(ROLE.COACH)
        ),
      [ROLE.PARTICIPANT]
    );
    permissionService.defineRole(
      ROLE.ADMIN,
      (): any => userService.getUser()
        .then(
          (user: User): boolean => user !== null && user.hasRole(ROLE.ADMIN)
        ),
      [ROLE.COACH]
    );
    permissionService.defineRole(
      ROLE.SUPER_ADMIN,
      (): any => userService.getUser()
        .then(
          (user: User): boolean => user !== null && user.hasRole(ROLE.SUPER_ADMIN)
        ),
      [ROLE.ADMIN]
    );

    authHttpService.onAccessDenied.subscribe(
      (response: Response) => {
        if (response.status === HTTP_STATUS_CODE.FORBIDDEN) {
          return;
        }

        notify.killAllModals();
        authHttpService.removeToken();
        userService.clearUser();

        if (/^\/login/.test(router.url)) {
          return;
        }

        router.navigate(['login']);
      },
      noop
    );

  }
}



// WEBPACK FOOTER //
// /dist/src/app/app.module.ts